import { RootState } from "@/modules/common";

export const selectIsEmptyBasket = (state: RootState) =>
  (state.basket.basket !== null && state.basket.basket.products.length === 0) ||
  (state.basket.basket.products.length === 1 &&
    state.basket.basket.products.find(
      product => product.id === "410d3ef3-a07e-4dff-b2e6-df04747b47e5"
    ));
